import React, { useState, useContext, useEffect } from "react";
import "./styles.css";
import { Images } from "../../theme";
import { GlobalContext } from "../../context/GlobalContext";
import { DotsLoader } from "../../components";
import { useTranslation } from "react-i18next";


export default function CheckOut({ rowData, onClose }) {
  const getContextItems = useContext(GlobalContext);
  let { check_promo_code, thirdLoader } = getContextItems;
  const { t } = useTranslation();


  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(false);

  function checkValidation() {
    if (!code) {
      setCodeError(t("Please_Enter"));
    } else {
      let payload = {
        code,
        user_id: rowData.id,
      };
      check_promo_code(payload, onClose);
    }
  }

  return (
    <div className="bg">
      <div className="center">
        <div
          className="container"
          style={{
            backgroundImage: `url(${Images.bg_image})`,
            borderRadius: 28,
            backgroundColor: "#E5E5E5",
          }}
        >
          <div className="row" style={{ paddingBottom: 50 }}>
            <div className="d-flex justify-content-center my-3">
              <img className="logo-icon" src={Images.logo_white} alt="image" />
            </div>

            <div className="col-sm-9 col-md-9 col-lg-5 mx-auto">
              <div className="card card-signin my-2 border-0">
                <div className="card-body">
                  <h5 className="card-title text-center heading_title">
                    {t("Promo_Code")}
                  </h5>
                  <form
                    action="javascript:void(0)"
                    className="form-signin mt-4 px-2"
                  >
                    <div className="form-label-group mb-3">
                      <div>
                        <label>{t("Code")}</label>
                        <input
                          className="input-field"
                          value={code}
                          type="text"
                          placeholder={t("Enter_Code_Here")}
                          onChange={(e) => {
                            setCodeError(false);
                            setCode(e.target.value);
                          }}
                        />
                      </div>
                      <div className="error_text">{codeError}</div>
                    </div>
                    <div className="pt-3" style={{ textAlign: "center" }}>
                      {thirdLoader ? (
                        <DotsLoader />
                      ) : (
                        <button
                          type="button"
                          className="btn-custom btn-light"
                          style={{
                            width: "100%",
                            borderRadius: 10,
                            height: 50,
                          }}
                          onClick={checkValidation}
                        >
                          {t("Submit")}
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
